export enum RegisterFlowStepGroupsEnum {
  'EMPTY' = 'EMPTY',
  'BEFORE_LOGIN' = 'BEFORE_LOGIN',
  'AFTER_LOGIN' = 'AFTER_LOGIN',
}
